import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem("tenjara_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch (_) {}
  return config;
});

export const BRAND = {
  name: "Tenjara Lombok",
  email: "tenjaralombok@gmail.com",
  phone: "+34 663 219 900",
  whatsapp: "34663219900",
  contact_name: "Rodrigo",
  address: "Kuta, Central Lombok, West Nusa Tenggara, Indonesia",
  instagram: "https://www.instagram.com/tenjaralombok/",
  instagram_mobile:
    "https://www.instagram.com/tenjaralombok?igsh=MWtmcm80b3lqbXBybg%3D%3D&utm_source=qr",
  facebook: "https://facebook.com/tenjaralombok",
};

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
